<div class="row mt-4 mb-4">
    <!-- <div class="col-6">
      <button class="btn" (click)="signin_with('google')">
        <img class="img-fluid" src="/assets/icons/google-icon.svg" alt="icon">
        <span>{{action}} with Google</span>
      </button>
    </div>
    <div class="col-3">
      <button class="btn"  (click)="signin_with('facebook')">
        <img class="img-fluid" src="/assets/icons/facebook-icon.svg" alt="icon">
      </button>
    </div>
    <div class="col-3">
      <button class="btn"  (click)="signin_with('linkedin')">
        <img class="img-fluid" src="/assets/icons/linkedin-icon.svg" alt="icon">
      </button>
    </div> -->
</div>

<!-- <h6 class="text-muted">use your email addresss</h6> -->
